import EverTrue from 'app';
import BaseRouter from 'base/base-router';
import TasksController from 'apps/tasks/controllers/tasks-controller';
import { TasksProvider } from 'apps/tasks/hooks/tasks-context';
import IsFlaggedController from 'components/flags/is-flagged-controller';
import TasksSummaryController from '../controllers/tasks-summary-controller';
import AutomatedTasksController from '../controllers/automated-tasks-controller';
import TaskDetailController from '../controllers/task-detail-controller';
import AutomatedTaskDetailController from '../controllers/automated-task-detail-controller';
import { EmailTemplatesProvider } from 'apps/outreach/email/templates/email-templates-context';
import { EmailSignaturesProvider } from 'apps/outreach/email/signatures/email-signatures-context';

class TasksRouter extends BaseRouter {
  static initClass() {
    this.prototype.routes = {
      'tasks(/)': 'index',
      'tasks/summary(/)': 'summary',
      'tasks/assigned': 'assigned',
      'tasks/ai-tasks': 'aiTasks',
      'tasks/automated(/)': 'automated',
      'tasks/automated/:id': 'automatedTaskDetail',
      'tasks/:id': 'task',
    };
  }

  index() {
    EverTrue.execute('setBrowserTitle', 'Tasks');
    this.currentView = (
      <IsFlaggedController flag="signal">
        <TasksProvider>
          <TasksController tab="" userType="OWNER" />
        </TasksProvider>
      </IsFlaggedController>
    );
    EverTrue.page.mount(this.currentView);
  }

  /**
   * Tasks Summary Page - shows both manual and automated tasks overview.
   */
  summary() {
    EverTrue.execute('setBrowserTitle', 'Tasks Summary');
    this.currentView = (
      <IsFlaggedController flags={['signal', 'cadenceV2Internal']}>
        <TasksSummaryController />
      </IsFlaggedController>
    );
    EverTrue.page.mount(this.currentView);
  }

  assigned() {
    EverTrue.execute('setBrowserTitle', 'Tasks | Assigned');
    this.currentView = (
      <IsFlaggedController flag="signal">
        <TasksProvider>
          <TasksController tab="assigned" userType="CREATOR_BUT_NOT_OWNER" />
        </TasksProvider>
      </IsFlaggedController>
    );
    EverTrue.page.mount(this.currentView);
  }
  aiTasks() {
    EverTrue.execute('setBrowserTitle', 'Task Suggestions | AI Tasks');
    this.currentView = (
      <IsFlaggedController flag="signal">
        <TasksProvider>
          <TasksController tab="ai-tasks" userType="OWNER" />
        </TasksProvider>
      </IsFlaggedController>
    );
    EverTrue.page.mount(this.currentView);
  }

  /**
   * Automated Tasks Page - shows scheduled tasks from cadences.
   */
  automated() {
    EverTrue.execute('setBrowserTitle', 'Automated Tasks');
    this.currentView = (
      <IsFlaggedController flags={['signal', 'cadenceV2Internal']}>
        <EmailTemplatesProvider>
          <EmailSignaturesProvider>
            <AutomatedTasksController />
          </EmailSignaturesProvider>
        </EmailTemplatesProvider>
      </IsFlaggedController>
    );
    EverTrue.page.mount(this.currentView);
  }

  //task detail page
  task(id) {
    EverTrue.execute('setBrowserTitle', 'Tasks');
    this.currentView = (
      <IsFlaggedController flags={['signal', 'cadenceV2Internal']}>
        <TaskDetailController taskId={id} />
      </IsFlaggedController>
    );
    EverTrue.page.mount(this.currentView);
  }

  /**
   * Automated Task Detail Page
   */
  automatedTaskDetail(id) {
    EverTrue.execute('setBrowserTitle', 'Automated Task Details');
    this.currentView = (
      <IsFlaggedController flags={['signal', 'cadenceV2Internal']}>
        <AutomatedTaskDetailController taskId={id} />
      </IsFlaggedController>
    );
    EverTrue.page.mount(this.currentView);
  }
}

TasksRouter.initClass();
export default TasksRouter;
